import { Box, Typography, Button, useTheme } from "@mui/material";
import { LoanPool } from "../../types/loanTypes";
import CowIcon from "../CowIcon";
import EmptyState from "./EmptyState";
import InvestmentPoolDetailView from "./InvestmentPoolDetailView";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../redux/store";
import {
  setCurrentLoanPoolView,
  setSelectedLoanPool,
} from "../../redux/uiSlice";
import InvestmentListView from "./InvestmentListView";

const InvestmentView: React.FC<{
  pools: LoanPool[];

  isMobile: boolean;
}> = ({ pools, isMobile }) => {
  const theme = useTheme();

  const { currentLoanPoolView, selectedLoanPool } = useAppSelector(
    (state: RootState) => state.ui
  );
  const dispatch = useAppDispatch();

  // Add this handler for the actual investment
  const handleInvestSubmit = async (amount: number, poolId: string) => {
    try {
      // Connect to your smart contract or API here
      console.log(`Investing ${amount} AGD in pool ${poolId}`);
      // await yourInvestmentFunction(amount, poolId);

      // After successful investment
      dispatch(setSelectedLoanPool(null));
      dispatch(setCurrentLoanPoolView("list"));
      // Optionally show a success message or refresh pool data
    } catch (error) {
      console.error("Investment error:", error);
      throw error; // This will be caught in the detail view
    }
  };

  return (
    <Box>
      {pools.length === 0 ? (
        <EmptyState
          icon={<CowIcon fill={theme.palette.text.secondary} size={48} />}
          title="No Investment Pools"
          description="Invest in cattle-backed loans and earn competitive returns"
          action={
            <Button variant="contained" disabled>
              Coming Soon
            </Button>
          }
        />
      ) : (
        <>
          {currentLoanPoolView === "list" ? (
            <InvestmentListView pools={pools} isMobile={isMobile} />
          ) : (
            selectedLoanPool && (
              <InvestmentPoolDetailView
                onBack={() => dispatch(setCurrentLoanPoolView("list"))}
                onInvest={handleInvestSubmit}
                isMobile={isMobile}
              />
            )
          )}
        </>
      )}
    </Box>
  );
};

export default InvestmentView;
